import { CarbonAccountingValues } from '../types';
import {
  CARBONACCOUNTING_INITIAL_VALUES,
  ENVIRONMENTAL_ITEMS_VALUES,
} from '../constant';
import { isEmpty } from 'lodash';
import { dateConvertions } from 'common/utils/dateFormats';
import { EntityEnvironmentalItemsType } from '..';
import { GetEntityDocument_entityDocument_entityEnvironmentalsByEntityId } from '../../../__generated__/GetEntityDocument';

interface DefaultValueProps {
  entityDocument: GetEntityDocument_entityDocument_entityEnvironmentalsByEntityId | undefined;
}

export const getDefaultValues = (props: DefaultValueProps) => {
  const { entityDocument } = { ...props };

  const environmentalItemsArray: EntityEnvironmentalItemsType[] =
    entityDocument?.nodes[0]?.entityEnvironmentalItems?.nodes?.map((ele) => {
      const {
        _isDeletable,
        _isUpdatable,
        entityEnvironmentalId,
        _isIntegerFormat,
        _isFloatFormat,
        _isAmountFormat,
        _rowTimestamp,
        environmentalImpactType,
        ...environmentalItemFields
      } = { ...ele };
      return {
        ...environmentalItemFields!,
        isIntegerFormat: ele._isIntegerFormat,
        isFloatFormat: ele._isFloatFormat,
        isAmountFormat: ele._isAmountFormat,
      };
    }) || [];

  let defaultValues: CarbonAccountingValues = {
    ...CARBONACCOUNTING_INITIAL_VALUES,
  };
  if (!isEmpty(entityDocument?.nodes?.[0])) {
    defaultValues = {
      ...entityDocument?.nodes?.[0]!,
      startDate: entityDocument?.nodes[0].startDate
        ? dateConvertions(entityDocument?.nodes[0].startDate)
        : null,
      endDate: entityDocument?.nodes[0].endDate
        ? dateConvertions(entityDocument?.nodes[0].endDate)
        : null,
      entityEnvironmentalItems:
        environmentalItemsArray.length > 0
          ? [...environmentalItemsArray]
          : [ENVIRONMENTAL_ITEMS_VALUES],
    };
  }
  return defaultValues;
};
